import * as crm from '../../constants/crm'
import * as mainActions from '../main'
import * as loginActions from '../login'
import Axios from 'axios'

const postNewLeadRequest = () => {
    return {
        type: crm.CRM_ADD_NEW_LEAD_REQUEST
    }
}

const postNewLeadSuccess = () => {
    return {
        type: crm.CRM_ADD_NEW_LEAD_SUCCESS
    }
}

const postNewLeadError = () => {
    return {
        type: crm.CRM_ADD_NEW_LEAD_ERROR
    }
}

const fetchLeadsSuccess = ({ leads }) => {
    return {
        type: crm.CRM_FETCH_LEADS,
        payload: { leads }
    }
}

const fetchLeadSuccess = ({ lead }) => {
    return {
        type: crm.CRM_FETCH_LEAD,
        payload: {
            lead: lead
        }
    }
}

export const fetchLeads = limit => async dispatch => {
    try {
        dispatch(mainActions.redirect(''))
        const response = await Axios.get(`/api/crm/kontakty/${limit}`)
        const data = response.data
        dispatch(fetchLeadsSuccess({ leads: data }))
    } catch (err) {
        console.log(err)
    }
}

export const fetchLead = id => async dispatch => {
    try {
        dispatch(mainActions.redirect(''))
        const response = await Axios.get(`/api/crm/kontakt/${id}`)
        dispatch(fetchLeadSuccess(response.data))
        dispatch(leadEditCheckPrefetch())
        if (response.data.lead.login_operatora_obsluga)
            dispatch(loginActions.fetchOperator(response.data.lead.login_operatora_obsluga))
    } catch (error) {
        console.log(error)
    }
}

export const addNewLead = obj => async dispatch => {
    dispatch(postNewLeadRequest())
    try {
        await Axios.put('/api/crm/addLead', obj)
    } catch (error) {
        dispatch(postNewLeadError())
    }

    dispatch(postNewLeadSuccess())
}
const addNewLeadActionRequest = () => ({ type: crm.CRM_ADD_NEW_LEAD_ACTION_REQUEST })
const addNewLeadActionError = () => ({ type: crm.CRM_ADD_NEW_LEAD_ACTION_ERROR })

const addNewLeadActionSuccess = (lead_id) => dispatch => {
    dispatch(fetchLead(lead_id))
    return { type: crm.CRM_ADD_NEW_LEAD_ACTION_SUCCESS }
}

export const changeLeadStatus = lead_id => async dispatch => {
    dispatch(addNewLeadActionRequest())
    try {
        await Axios.put(`/api/crm/kontakt/dzialania/new/${lead_id}`, { lead_id, type: "Zmiana statusu" })
        dispatch(addNewLeadActionSuccess(lead_id))
        //dispatch(changeLeadActionName(lead_id, 'last', 'Zmiana statusu'))
    } catch (error) {
        console.log(error)
    }
}

export const addNewLeadAction = lead_id => async dispatch => {
    dispatch(addNewLeadActionRequest())
    try {
        await Axios.put(`/api/crm/kontakt/dzialania/new/${lead_id}`, { lead_id })
        dispatch(addNewLeadActionSuccess(lead_id))
    } catch (error) {
        console.log(error)
        dispatch(addNewLeadActionError())
    }
}

const deleteLeadActionRequest = () => ({ type: crm.CRM_DELETE_LEAD_ACTION_REQUEST })
const deleteLeadActionError = () => ({ type: crm.CRM_DELETE_LEAD_ACTION_ERROR })
const deleteLeadActionSuccess = lead_id => dispatch => {
    dispatch(fetchLead(lead_id))
    return { type: crm.CRM_DELETE_LEAD_ACTION_SUCCESS }
}
export const deleteLeadAction = (lead_id, action_id) => async dispatch => {
    dispatch(deleteLeadActionRequest())
    try {
        await Axios.post('/api/crm/kontakt/dzialania/delete', { lead_id, action_id })
        dispatch(deleteLeadActionSuccess(lead_id))
    } catch (error) {
        console.log(error)
        dispatch(deleteLeadActionError())
    }
}

export const changeLeadActionName = (lead_id, action_id, action_name) => {
    return {
        type: crm.CRM_CHANGE_LEAD_ACTION_NAME,
        payload: {
            lead_id, action_id, action_name
        }
    }
}

const postLeadActionNameRequest = () => ({ type: crm.CRM_POST_LEAD_ACTION_NAME_REQUEST })
const postLeadActionNameError = () => ({ type: crm.CRM_POST_LEAD_ACTION_NAME_ERROR })
const postLeadActionNameSuccess = lead_id => dispatch => {
    dispatch(fetchLead(lead_id))
}

export const postLeadActionName = (lead_id, action_id, action_name) => async dispatch => {
    dispatch(postLeadActionNameRequest())
    try {
        await Axios.post('/api/crm/kontakt/dzialania/updateActionName', {
            lead_id, action_id, action_name
        })
        dispatch(postLeadActionNameSuccess(lead_id))
    } catch (error) {
        dispatch(postLeadActionNameError())
        console.log(error)
    }
}

export const postStatusChange = (id, status) => dispatch => {
    try {
        Axios.post('/api/crm/kontakt/status', { id, status })
        // dispatch(fetchLead(id))
    } catch (error) {
        console.log(error)
    }
}

export const statusChangeModalClose = () => ({ type: crm.CRM_LEAD_ACTION_STATUS_CHANGE_MODAL_CLOSE })
export const actionStatusChange = value => ({ type: crm.CRM_LEAD_ACTION_STATUS_CHANGE, payload: value })

export const statusChangeModalCancel = (lead_id, action_id) => async dispatch => {
    try {
        dispatch(deleteLeadAction(lead_id, action_id))
        dispatch(statusChangeModalClose())
    } catch (error) {
        console.log(error)
    }
}

export const fetchPowiaty = () => async dispatch => {
    try {
        const response = await Axios.get(`/api/crm/powiaty`)
        dispatch(fetchPowiatySuccess(response.data))
        dispatch(leadEditCheckPrefetch())
    } catch (error) {
        console.log(error)
    }
}

const fetchPowiatySuccess = powiaty => {
    return {
        type: crm.CRM_FETCH_POWIATY,
        payload: powiaty
    }
}

export const fetchOperators = () => async dispatch => {
    try {
        const response = await Axios.get('/api/login/operator?czy_obsluga_crm=true')
        dispatch(fetchOperatorsSuccess(response.data))
        dispatch(leadEditCheckPrefetch())
    } catch (error) {
        console.log(error)
    }
}

const fetchOperatorsSuccess = operators => {
    return {
        type: crm.CRM_FETCH_OPERATORS,
        payload: operators
    }
}

export const powiatChange = powiat => {
    return {
        type: crm.CRM_POWIAT_CHANGE,
        payload: powiat
    }
}

export const _powiatChange = powiat => {
    return {
        type: crm.CRM__POWIAT_CHANGE,
        payload: powiat
    }
}

export const addNewLeadAlertShown = () => {
    return {
        type: crm.CRM_ADD_NEW_LEAD_ALERT_SHOWN
    }
}

export const setZrodlaKontaktuOptions = (options) => {
    return {
        type: crm.CRM_SET_ZRODLA_KONTAKTU_OPTIONS,
        payload: options
    }
}

const leadEditResetPrefetch = () => {
    return {
        type: crm.CRM_LEAD_EDIT_RESET_PREFETCH
    }
}

const leadEditCheckPrefetch = () => {
    return {
        type: crm.CRM_LEAD_EDIT_CHECK_PREFETCH
    }
}

export const prepareDataForEdit = id => dispatch => {
    dispatch(leadEditResetPrefetch())
    dispatch(fetchLead(id))
    dispatch(fetchPowiaty())
    dispatch(fetchOperators())
}

const postEditedLeadError = () => { return { type: crm.CRM_POST_LEAD_ACTION_ERROR } }
const postEditedLeadSuccess = () => { return { type: crm.CRM_POST_LEAD_ACTION_SUCCESS } }

export const postEditedLead = values => async dispatch => {
    try {
        await Axios.post('/api/crm/editLead/', values)
        dispatch(postEditedLeadSuccess)
    } catch (error) {
        dispatch(postEditedLeadError())
    }
}

export const markDeletedLead = (id, limit) => async dispatch => {
    try {
        await Axios.delete(`/api/crm/kontakt/${id}`)
        dispatch(fetchLeads(limit))
    } catch (error) {
        console.log(error)
    }
}

const fetchTypyImportowSuccess = data => {
    return {
        type: crm.CRM_TYPY_IMPORTOW_SUCCESS,
        payload: data
    }
}

export const fetchTypyImportow = () => async dispatch => {
    try {
        let response = await Axios.get('/api/crm/typyImportow')
        dispatch(fetchTypyImportowSuccess(response.data))
    } catch (error) {
        console.log(error)
    }
}

export const importFromFileSubmit = values => async dispatch => {
    try {
        let ret = await Axios.post(`/api/crm/csvUpload`, values)
        dispatch(importFromFileSuccess(ret.data))
    } catch (error) {
        dispatch(importFromFileError(error))
    }
}

export const importFromFileSuccess = data => {
    return {
        type: crm.CRM_IMPORT_FILE_SUCCESS,
        payload: data
    }
}

export const importFromFileError = data => {
    return {
        type: crm.CRM_IMPORT_FILE_ERROR,
        payload: data
    }
}

export const selectImportFormat = id => {
    return {
        type: crm.CRM_SELECT_IMPORT,
        payload: id
    }
}

export const contactListFilterChange = payload => {
    return {
        type: crm.CRM_CONTACT_LIST_FILTER_CHANGE,
        payload: payload
    }
}

export const contactListSortChange = payload => {
    return {
        type: crm.CRM_CONTACT_LIST_SORT_CHANGE,
        payload: payload
    }
}

export const contactListResizeChange = payload => {
    return {
        type: crm.CRM_CONTACT_LIST_RESIZE_CHANGE,
        payload: payload
    }
}

export const contactListConfSaveToLocalStorage = () => (dispatch, getState) => {
    let payload = {}
    payload = getState().crm.contactListConf
    dispatch(
        {
            type: crm.CRM_CONTACT_LIST_CONFIG_SAVE_TO_LOCAL_STORAGE,
            payload: payload
        }
    )
}

export const contactListConfGetFromLocalStorage = () => {
    return {
        type: crm.CRM_CONTACT_LIST_CONFIG_GET_FROM_LOCAL_STORAGE,
    }
}

export const contactListConfUpdate = config => ({
    type: crm.CRM_CONTACT_LIST_CONFIG_UPDATE,
    payload: config
})
